import { useQuery } from "@tanstack/react-query";

async function getAttachmentRequest(attachmentUrl: string): Promise<Blob> {
  return fetch(attachmentUrl, {
    method: "GET",
  }).then((response) => response.blob());
}
export default function useWorkspaceAttachmentBlob(attachmentUrl: string) {
  const queryKey = ["attachmentBlob", attachmentUrl];

  const { data: attachmentBlob, isLoading: isLoadingAttachmentBlob } = useQuery(
    {
      queryKey: queryKey,
      queryFn: () => getAttachmentRequest(attachmentUrl),
      enabled: !!attachmentUrl,
      staleTime: Infinity,
    },
  );

  return {
    attachmentBlob,
    isLoadingAttachmentBlob,
  };
}
